import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import PricingPage from "@/pages/PricingPage";
import ContactPage from "@/pages/ContactPage";
import LoginPage from "@/pages/LoginPage";
import ClientPortal from "@/pages/ClientPortal";
import AdminPortal from "@/pages/AdminPortal";
import MagicVerify, { AuthCallback } from "@/pages/MagicVerify";
import ResetPassword from "@/pages/ResetPassword";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ProjectPage from "@/pages/ProjectPage";
import BlogPage, { BlogPostPage } from "@/pages/BlogPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
      const publicPage = ["/", "/pricing", "/contact"].includes(location.pathname) || location.pathname.startsWith("/work/") || location.pathname.startsWith("/blog");
  return (
    <>
      <ScrollToTop />
      <SmoothScroll />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/work/:id" element={<ProjectPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/portal/login" element={<LoginPage role="client" />} />
        <Route path="/portal" element={<ClientPortal />} />
        <Route path="/admin/login" element={<LoginPage role="admin" />} />
        <Route path="/admin" element={<AdminPortal />} />
        <Route path="/auth/magic" element={<MagicVerify />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
      </Routes>
      {publicPage && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <ContentProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </ContentProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
